import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppServerAPI } from '@sdbn/common';
import { RoutingLogDetails, RoutingLogQuery } from './routing-log-inspector.model';

@Injectable({
  providedIn: 'root'
})
export class TransportRoutinglogInspectorService {

  constructor(
    private appServerAPI: AppServerAPI
  ) { }

  public findRoutingLogDetails(routingLogKey: string): Observable<RoutingLogDetails> {
    const query = new RoutingLogQuery();
    query.key = routingLogKey;
    return this.appServerAPI.execute<RoutingLogDetails>('/client/admin/routing-log-inspector', query)
      .pipe(
        map(rl => new RoutingLogDetails(rl))
      );
  }
}
